import { Box, Button, Stack } from "@mui/material";
import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import policyService from "../services/policyService";
import { contentBoxStyle, ThemeModeContext } from "../shared/Theme";

const EmployeePolicy = () => {
	
    const themeModeContext = useContext(ThemeModeContext);
	const imageUrls = {
		"light": "/cymplify-logo_light.png",
		"dark": "/cymplify-logo_dark.png",
	}
	const imageUrl = imageUrls[themeModeContext.themeMode];
    const { token } = useParams();

    const handleDownloadClick = () => {
        policyService.downloadCompanyEmployeePolicy(token);
    };

	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Box sx={contentBoxStyle}>
					<Box sx={{ textAlign: "center" }}>
                        <Stack direction="column">
                            <Link to="/">
                                <img src={imageUrl} alt="cymplify logo" />
                            </Link>
                            <Box>
                                <Button onClick={handleDownloadClick}>Click to download your policy</Button>
                            </Box>
                        </Stack>
					</Box>
                </Box>
            </Box>
		</Box>
	);
}

export default EmployeePolicy;